import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import { DialogActions, TextField } from "@mui/material";

const DeleteModel = ({
  isdeletePopup,
  Transition,
  setisdeletePopup,
  isdeleteLoading,
  handleDelete,
  sessionId
}) => {
  return (
    <div>
      <Dialog
        open={isdeletePopup}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setisdeletePopup(false)}
        aria-describedby="alert-dialog-slide-description"
        id="DeleteDialog"
      >
        <DialogTitle>Are you sure want to delete this conversation {sessionId}</DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You'll no longer see this chat here. This will also delete related
            activity like prompts, responses, and feedback from your snow query
            ai tool activity
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="submit_btn"
            onClick={() => setisdeletePopup(!isdeletePopup)}
          >
            Cancel
          </Button>

          <Button
            className="submit_btn"
            disabled={isdeleteLoading}
            onClick={() => handleDelete(sessionId)}
            autoFocus
          >
            {isdeleteLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span style={{ paddingLeft: "10px" }}>Removing...</span>
              </>
            ) : (
              "Remove"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteModel;
